import { jsPDF } from "jspdf";

/* The receipt design lives in public/receipt.js so the admin panels (plain HTML,
   no bundler) render the exact same PDF. It's loaded via a script tag in
   public/index.html; we hand it our bundled jsPDF so the portal doesn't depend
   on a CDN at runtime. */
export async function generateReceipt(fee) {
  if (typeof window.generateReceipt !== "function") {
    throw new Error("receipt.js failed to load");
  }
  return window.generateReceipt(fee, jsPDF);
}
